/**
 * A one-shot "open Settings at this section when it next mounts".
 *
 * The setup wizard's "Go →" buttons have to land on a specific Settings
 * section and tab — Company → Team Members, or Sales — and the wizard is
 * usually open on the dashboard when they are clicked. Settings is lazy
 * (SubNav.jsx:22), so the navigate event has to mount its chunk first, and
 * there is no delay that is both short enough to feel immediate and long
 * enough to be safe on a slow connection.
 *
 * A flag the mounting component consumes has no race to lose. Deliberately not
 * state or context, for the same reason as enrichIntent.js: nothing re-renders
 * on it, and it is read exactly once.
 *
 * The anchor is scrolled to rather than navigated to. Every Settings field
 * already lives in a section carrying an id (`company-logo-section`,
 * `public-site-url-field`, …) because the Joyride tour targets them, so
 * pointing at the right part of a long tab costs nothing new — and landing
 * someone at the top of a screen they have already been told is 2,000px long
 * is how "Go →" becomes "go and look for it".
 */

let pending = null;

/**
 * Ask for Settings to open at a section as soon as it is available.
 * @param {{section: string, tab?: string, anchor?: string}} target
 */
export function requestSettingsSection(target) {
    pending = target || null;
}

/** Read and clear the request. Returns the target at most once per request. */
export function consumeSettingsSection() {
    const was = pending;
    pending = null;
    return was;
}
